export interface MapProctorConfig {
  baseUrl: string;
  apiKey: string;
}

export interface GetMapProctorConfigResult {
  baseUrl?: string;
  apiKey?: string;
  error?: string;
}

export async function getMapProctorConfig(): Promise<GetMapProctorConfigResult> {
  try {
    // Hardcoded MAP proctor configuration
    return {
      baseUrl: 'https://qeeujv9hyb.execute-api.us-east-1.amazonaws.com/prod',
      apiKey: 'atADP8hxz37kKYSFyjvF39PHFlBZiHuf9OEkA8G4',
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
}
